import { useSyncExternalStore } from "react";

/**
 * Tiny shared store for the sample exam confirmation modal.
 *
 * The modal can be triggered from the sidebar or from a locked page card.
 * Both places need to know when it is open so only one overlay is visible
 * at a time (the locked card hides itself while the modal is up).
 */
let open = false;
const listeners = new Set<() => void>();

const emit = () => listeners.forEach((l) => l());

export const setSampleExamOpen = (next: boolean) => {
  if (open === next) return;
  open = next;
  emit();
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => open;

export const useSampleExamOpen = () => useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
